module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/shared/main/vehicle/motorcycle/motorcycle.component.css
// module id = ./src/app/components/calculator/calculator-item/shared/main/vehicle/motorcycle/motorcycle.component.css
// module chunks = main